<template>
  <div>
    <table v-if="hasDiffs" class="mergeTable employments" width="100%">
        <thead>
        <tr>
          <th align="center" width="33%" style="padding-right: 5px;"><a @click="res = JSON.parse(JSON.stringify(o))">Старое</a>
          </th>
          <th align="center" width="34%"
              style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;"> ← diff →
          </th>
          <th align="center" width="33%" style="padding-left: 5px;"><a
              @click="res = JSON.parse(JSON.stringify(n))">Новое</a></th>
        </tr>
        </thead>
        <tbody v-for="(eee,index) in maxCount">
        <tr>
          <td v-if="oToText[index]" :class="{'selected': resToText[index] === oToText[index]}" valign="top"
              style="padding-right: 5px;">
            <a @click="setRes(index, 'old')">{{ oToText[index] }}</a>
          </td>
          <td v-else valign="top" style="padding-right: 5px;"><a @click="res.splice(index,1)">X</a></td>
          <td valign="top" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;">
            <span class="diff" v-html="getDiff(index)"/>
          </td>
          <td v-if="nToText[index]"
              :class="{'selected': resToText[index] === nToText[index] && nToText[index] !== oToText[index]}" valign="top"
              style="padding-left: 5px;">
            <a @click="setRes(index, 'new')">{{ nToText[index] }}</a>
          </td>
          <td v-else valign="top" style="padding-right: 5px;"><a @click="res.splice(index,1)">X</a></td>
        </tr>
        </tbody>
    </table>
    <table class="mergeTable employments" width="100%">
      <thead>
      <tr>
        <th align="center" colspan="100%">Актуальное</th>
      </tr>
      </thead>
      <tbody v-for="(row, emplRowIndex) in res" class="hover">
      <tr style="height: 31px">
        <td colspan="100%" class="selected">
          <input v-model="row.name"
                 ref="employment"
                 placeholder="Место работы"
                 class="employmentName"
                 @paste="onPasteEmployments(emplRowIndex, $event)"
                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'">
        </td>
      </tr>
      <tr style="height: 31px">
        <td  colspan="25%" class="selected">
          <input v-model="row.position"
                 @paste="onPastePosition(emplRowIndex, $event)"
                 ref="position"
                 class="employmentPosition"
                 placeholder="Должность"
                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'">
        </td>
        <td colspan="7%" style="padding-left: 5px;" class="selected">
          <v-select
              v-model="row.m1"
              placeholder="Мес"
              @close="validateEmploymentDates"
              :options='[
                                { value: "", text: "\u00a0" },
                                { value: "1", text: "Янв" },
                                { value: "2", text: "Фев" },
                                { value: "3", text: "Март" },
                                { value: "4", text: "Апр" },
                                { value: "5", text: "Май" },
                                { value: "6", text: "Июнь" },
                                { value: "7", text: "Июль" },
                                { value: "8", text: "Авг" },
                                { value: "9", text: "Сен" },
                                { value: "10", text: "Окт" },
                                { value: "11", text: "Ноя" },
                                { value: "12", text: "Дек" },
                            ]'
          />
        </td>
        <td colspan="6%"  style="padding-left: 5px;" class="selected">
            <ValidationProvider
                v-slot="{ errors }"
                :rules="{numeric:true, min_value:1900, max_value:currentYear}"
            >
                <input v-model="row.y1" placeholder="Год" type="number" min="1900"
                     :max="currentYear"  v-units.literal="`г`"
                     style="text-align: left !important;"
                     :required="(row.m1 != '')"
                     @blur="validateEmploymentDates"

                     :class="{'hasError' : errors[0]}"
                     v-tooltip="{
                       content: errors[0],
                       template: $errTemplate,
                    }"
              />
            </ValidationProvider>
        </td>
        <td colspan="3%" class="selected" align="center">по</td>
        <td colspan="7%" class="selected">
          <select v-model="row.m2" placeholder="Мес" @change="validateEmploymentDates" :disabled="row.now">
            <option></option>
            <option value="1">Янв</option>
            <option value="2">Фев</option>
            <option value="3">Март</option>
            <option value="4">Апр</option>
            <option value="5">Май</option>
            <option value="6">Июнь</option>
            <option value="7">Июль</option>
            <option value="8">Авг</option>
            <option value="9">Сен</option>
            <option value="10">Окт</option>
            <option value="11">Ноя</option>
            <option value="12">Дек</option>
          </select>
        </td>
        <td colspan="6%" style="padding-left: 5px;" class="selected">

            <ValidationProvider
                v-slot="{ errors }"
                :rules="{numeric:true, min_value:1900, max_value:currentYear}"
            >
              <input v-model="row.y2" placeholder="Год" type="number" min="1900"
                     :max="currentYear"  v-units.literal="`г`"
                     style="text-align: left !important;" :disabled="row.now" class="year2"
                     :required="(row.m2 != '')" @blur="validateEmploymentDates"

                     :class="{'hasError' : errors[0]}"
                     v-tooltip="{
                       content: errors[0],
                       template: $errTemplate,
                    }"
              />
            </ValidationProvider>
        </td>
        <td colspan="20%" class="selected" width="160">
          <label>
            <input style="margin-left: 10px;" type="checkbox" v-model="row.now">
            <span>по&nbsp;наст.&nbsp;время</span>
          </label>
        </td>
        <td colspan="26%" class="selected" align="right">
          <button class="small redHover square" @click.prevent="removeEmployment(emplRowIndex)" tabindex="-1"><i
              class="far fa-trash-can"></i></button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr style="height: 38px;">
        <td colspan="100%" style="text-align: center;">
          <button class="small addEmployment" @click.prevent="addEmployment(true)" tabindex="-1">
              Добавить место работы
          </button>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>

</template>
<script>
import Base from "../Base.vue";
import DiffMatchPatch from 'diff-match-patch';
import _ from "lodash";

export default {
  mixins: [Base],
  props: {
    o: {
      type: [Array],
      default: ''
    },
    n: {
      type: [Array],
      default: ''
    },
    f: {
      type: [Array],
      default: ''
    },
  },
  data: function () {
    return {
      resToText: [],
      MONTHSHORT: ["", "янв", "фев", "мар", "апр", "мая", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"]
    }
  },
  created() {
    this.resToText = this.res.map((item) => this.resMap(item));
  },
  methods: {

    setRes(index, type) {
      if (type === 'old') {
        this.res.splice(index, 1, JSON.parse(JSON.stringify(this.o[index])));
      }
      if (type === 'new') {
        this.res.splice(index, 1, JSON.parse(JSON.stringify(this.n[index])));
      }
    },
    onPasteEmployments (index, e) {
      let input = this.$refs.employment[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        let newText = input.value.substring(0, input.selectionStart) + text + input.value.substring(input.selectionEnd);
        this.res[index].name = _.upperFirst(newText.split('\n').join(' ').trim());
      } else {
        this.textToEmployments(text, index);
      }

      e.preventDefault();
    },
    onPastePosition(index, e) {
      let input = this.$refs.position[index];
      let text = e.clipboardData.getData('text/plain');

      let newText = input.value.substring(0, input.selectionStart) + text + input.value.substring(input.selectionEnd);
      this.res[index].position = _.upperFirst(newText.split('\n').join(' ').trim());
      e.preventDefault();
    },
    textToEmployments (line, index) {
      line = line.split('\n').join(' ').trim();
      if (!_.isEmpty(line)) {
        let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
          let y = parseInt(val);
          if ((1900 <= y && y <= 2050)) {
            acc.push('' + y);
            return acc;
          }
          return acc;
        }, []);

        let data = {
          name:     this.cutLastComma(_.upperFirst(line).trim()),
          position: '',
          m1:       '',
          y1:       year[0] || '',
          m2:       '',
          y2:       year[1] || '',
          now:      false
        };

        if (index === null) {
          this.inputEmployment();
          index = this.res.length - 1;
        }

        this.res[index] = this.res[index] ? {
          name: data.name,
          position: data.position ? data.position : this.res[index].position,
          m1: data.m1 ? data.m1 : this.res[index].m1,
          y1: data.y1 ? data.y1 : this.res[index].y1,
          m2: data.m2 ? data.m2 : this.res[index].m2,
          y2: data.y2 ? data.y2 : this.res[index].y2,
          now: data.now ? data.now : this.res[index].now,
        } : data;

        index++;
      }

      this.res = JSON.parse(JSON.stringify(this.res));
      this.inputEmployment();
    },
    addEmployment() {
      this.res.push({name: '', position: '', m1: '', y1: '', m2: '', y2: '', now: false});
    },
    removeEmployment: function (index) {
      this.res.splice(index, 1);
    },
    inputEmployment() {
      if (this.res.length === 0 || (this.res[this.res.length - 1] !== undefined)
          && (
              (this.res[this.res.length - 1].name !== '')
              || (this.res[this.res.length - 1].position !== '')
          ))
          this.addEmployment();
    },
    validateEmploymentDates () {
      let isError = false;

      for (const [key, employment] of Object.entries(this.res)) {
        if (employment.now || !employment.y1 || !employment.y2) {
          document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
          continue;
        }

        let date1 = new Date(employment.y1, employment.m1 - 1, 1);
        let date2 = new Date(employment.y2, employment.m2 - 1, 1);

        if (date2 < date1) {
          document.querySelectorAll('.employments input.year2')[key].classList.add('attentionValidationOnSubmitError');
          isError = true;
        } else {
          document.querySelectorAll('.employments input.year2')[key].classList.remove('attentionValidationOnSubmitError');
        }
      }

      return isError;
    },
    resMap(item) {
      return  item.name + ' '
          + (item.position ?? '')
          + ((item.y1 || item.m1) ? ' c ' : '') +
          (item.m1 ? this.MONTHSHORT[item.m1]+' ' : '' )
          + (item.y1 ?? '') + ' '
          + (item.m2 ? ' по ' +this.MONTHSHORT[item.m2]+' ' : ' ' )
          + (item.y2 ?? '')
          + (item.now ? 'по настоящее время': '');
    },
    getDiff(index) {
      let dmp = new DiffMatchPatch();
      let d = dmp.diff_main(this.oToText[index] ?? '', this.nToText[index] ?? '');
      dmp.diff_cleanupEfficiency(d);
      return dmp.diff_prettyHtml(d);
    },
    cutLastComma(text) {
      if (text[text.length - 1] === ',') {
        text = text.slice(0, text.length - 1);
      }

      return text;
    },
  },
  watch: {
    res: {
      deep: true,
      handler (value) {
        this.resToText = value.map((item) => this.resMap(item));
      }
    },
  },
  computed: {
    hasDiffs() {
      return !_.isEqual(this.o, this.n)
    },
    currentYear() {
      return new Date().getFullYear() ?? 2400;
    },
    oToText() {
      return this.o.map((item) => this.resMap(item))
    },
    nToText() {
      return this.n.map((item) => this.resMap(item))
    },
    maxCount() {
      return Math.max(this.oToText.length, this.nToText.length)
    },
  }
}
</script>
